import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentValidacaoDadosUsuario from './ContentValidacaoDadosUsuario';

const ArtesFacil = () => {
  return (
    <>
      <HeaderApp />
      <ContentValidacaoDadosUsuario />
      <Bottom />
    </>
  );
};

export default ArtesFacil;
